import React, { useState } from "react";
import { useEffect } from "react";
import { Form } from "react-bootstrap";
import { scales } from "../../../../../colorscaleUtils";
import Gradient from "../../../../../components/Gradient";
import { DWEntityLayer } from "../../../deckgl/DWEntityLayer";
import { MapLayer } from "../../../deckgl/MapLayer";
import { dcRound } from "../../../utils/misc";

type Prop = {
    awaitedLayerUpdate: number,
    setAwaitedLayerUpdate: Function,
    index: number,
    layer2: DWEntityLayer,
    layer: MapLayer,
    onChange: () => void,
    visibleSelection: boolean,
    selectedLayerId: string | null,
    setSelectedLayerId: Function,
    setUpdateHistogramId: Function,
    setUpdateHistogramLoaded: Function,
    updateHistogramId: number,
    updateHistogramLoaded: boolean,
    dwFilters: any,
    setColorRampMaxMin: Function, 
    colorRampMaxMin: Array<number> | null, 
    continueOtherQueriesAfterThisLayer?: boolean
    setReadyToLoadSoilHorizonData: Function,
    readyToLoadSoilHorizonData: boolean,
 };

const GLMapLayer = ({ awaitedLayerUpdate, setAwaitedLayerUpdate, index,layer2, layer, onChange, visibleSelection, selectedLayerId, setSelectedLayerId, setUpdateHistogramId, setUpdateHistogramLoaded, updateHistogramId, updateHistogramLoaded, dwFilters, setColorRampMaxMin, colorRampMaxMin, continueOtherQueriesAfterThisLayer, setReadyToLoadSoilHorizonData, readyToLoadSoilHorizonData }: Prop) => {
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [visible, setVisible] = useState<boolean>(layer.visible);
    const [awaitedLayer, setAwaitedLayer] = useState<MapLayer | null>(null);
    
    useEffect(() => {
        const loadData = async () => {
            //console.log("A091825 layer", layer);  
            //console.log("A091825 index", index);  
            console.log("A091825 awaitedLayerUpdate", awaitedLayerUpdate);  
            setAwaitedLayerUpdate(0);
            await layer.load();
            console.log("A091625 awaited layer", layer);
            //setAwaitedLayer(layer);
            setAwaitedLayerUpdate((prev:any) => prev + 1 );
            onChange();
            if (layer2._id === selectedLayerId){
                layer2.getTransform(dwFilters).then(function(response:any) {
                    setColorRampMaxMin( response.find((e:any) => e.hasOwnProperty('colorRampMaxMin')) ? response.find((e:any) => e.hasOwnProperty('colorRampMaxMin')).colorRampMaxMin : null);
                    if (layer.id === selectedLayerId){
                        setUpdateHistogramId((prev:any) => prev + 1 );
                        setUpdateHistogramLoaded(true);
                    }
                });
            }
        }
        if (index === 0){ // request geojson on only the first layer
            loadData();
        }
    }, []);

    useEffect(() => {
        let cancelled = false;

        const setData = async () => {
            console.log("AA091625 layer", layer);
            console.log("AA091625 index", index);
            console.log("AA091625 awaitedLayerUpdate", awaitedLayerUpdate);

            try {
                // Ensure we truly wait if a Promise is returned.
                const maybePromise = layer.syncWithAwaited?.();
                if (maybePromise && typeof maybePromise.then === "function") {
                    await maybePromise;
                } else {
                    // Fallback: force async boundary in case syncWithAwaited is sync.
                    await Promise.resolve();
                }

                if (cancelled) return;

                onChange();

                if (layer2._id === selectedLayerId) {
                    layer2.getTransform(dwFilters).then((response: any) => {
                        if (cancelled) return;
                        setColorRampMaxMin(
                            response.find((e: any) => e.hasOwnProperty("colorRampMaxMin"))
                                ? response.find((e: any) => e.hasOwnProperty("colorRampMaxMin")).colorRampMaxMin
                                : null
                        );
                        if (layer.id === selectedLayerId) {
                            setUpdateHistogramId((prev: any) => prev + 1);
                            setUpdateHistogramLoaded(true);
                        }
                    });
                }

                if (continueOtherQueriesAfterThisLayer) {
                    console.log("AA092225 readyToLoadSoilHorizonData, awaitedLayerUpdate", readyToLoadSoilHorizonData, awaitedLayerUpdate);
                    if (!readyToLoadSoilHorizonData && awaitedLayerUpdate > 0) {
                        console.log("AA092225 ------> setReadyToLoadSoilHorizonData(true) index, readyToLoadSoilHorizonData", index, readyToLoadSoilHorizonData);
                        setReadyToLoadSoilHorizonData(true);
                    }
                }
            } catch (err) {
                console.error("syncWithAwaited error:", err);
            }
        };

        console.log("A091825 awaitedLayerUpdate", awaitedLayerUpdate);
        if (index !== 0 && awaitedLayerUpdate > 0) {
            setData();
        }

        return () => { cancelled = true; };
    }, [awaitedLayerUpdate /*, index, layer, layer2, selectedLayerId, dwFilters, continueOtherQueriesAfterThisLayer, readyToLoadSoilHorizonData*/]);
    
    useEffect(() => {
        if (layer.id === selectedLayerId){
            layer.visible = visibleSelection;
            setVisible(visibleSelection);
            onChange();
         }else{
            layer.visible = false;
            setVisible(false);
            onChange();
         }
    }, [visibleSelection, selectedLayerId, updateHistogramId]);

    useEffect(() => {
        console.log("updateHistogramLoaded", updateHistogramLoaded)
    }, [updateHistogramLoaded]);

    useEffect(() => {
        //console.log("032423 updateHistogramLoaded", updateHistogramLoaded)
        //console.log("032423 updateHistogramId", updateHistogramId)
        if (updateHistogramLoaded && (layer2._id === selectedLayerId)){
            layer2.getTransform(dwFilters).then(function(response:any) {
                //console.log("032423 response", response);
                //console.log("032423 layer", layer);
                //console.log("032423 layer2", layer2);
                //console.log("032423 selectedLayerId", selectedLayerId);
                setColorRampMaxMin( response.find((e:any) => e.hasOwnProperty('colorRampMaxMin')) ? response.find((e:any) => e.hasOwnProperty('colorRampMaxMin')).colorRampMaxMin : null);
              });
        }
    }, [updateHistogramId]);

    return (<>
            {/*console.log("D021524 colorRampMaxMin", colorRampMaxMin)}
            {console.log("D021524 layer", layer)}
    {console.log("D021524 layer2", layer2)*/}
            {(
                (layer.getColorRamp() != null) 
                && (layer.id === selectedLayerId) 
                && (layer2._name !== "Treatment (color)") 
                && (layer2._name !== "Cultivar")
                && colorRampMaxMin
            ) 
                ? <div className="mt-2">
                        <div style={{width: "100%", height: 40, textAlign: "center", }}>
                            <Gradient width={240} height={15} ramp={scales[layer.getColorRamp()!]} inverse={true} />
                            <br/>
                            <div style={{height: 15, width:240, display:'inline-block'}}>
                                <div style={{float:'left'}}>{`${(colorRampMaxMin[0]!==undefined && colorRampMaxMin[0]!==null) ? dcRound(colorRampMaxMin[0]).toString() : ""}`}</div>
                                <div style={{float:'right'}}>{`${(colorRampMaxMin[1]!==undefined && colorRampMaxMin[1]!==null) ? dcRound(colorRampMaxMin[1]).toString() : ""}`}</div>
                            </div>
                        </div>
                    </div>
                :   <div style={{width: "100%", height: "5px", textAlign: "center", }}>
                    </div>
            } 

            { errorMessage && 
                <div>{errorMessage}</div>
            }
        </>
    );
}

export default GLMapLayer;